import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/svg/icon-sprite.svg'


const _hoisted_1 = _imports_0 + '#pencil'
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_6 = {
  key: 0,
  class: "table"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { colspan: "2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12 project-list" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = {
  class: "nav nav-tabs border-tab",
  id: "top-tab",
  role: "tablist"
}
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = {
  class: "nav-link active",
  id: "profile-top-tab",
  "data-bs-toggle": "tab",
  href: "#top-equipe",
  role: "tab",
  "aria-controls": "top-equipe",
  "aria-selected": "false"
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = {
  class: "nav-link",
  id: "profile-top-tab",
  "data-bs-toggle": "tab",
  href: "#top-produits",
  role: "tab",
  "aria-controls": "top-produits",
  "aria-selected": "false"
}
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = {
  class: "nav-link",
  id: "contact-top-tab",
  "data-bs-toggle": "tab",
  href: "#top-inventaire-partielle",
  role: "tab",
  "aria-controls": "top-inventaire-partielle",
  "aria-selected": "false"
}
const _hoisted_22 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_23 = {
  class: "tab-content",
  id: "top-tabContent"
}
const _hoisted_24 = {
  class: "tab-pane fade active",
  id: "top-equipe",
  role: "tabpanel",
  "aria-labelledby": "top-equipe-tab"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "table display" }
const _hoisted_28 = { class: "product-names" }
const _hoisted_29 = { class: "f-light" }
const _hoisted_30 = { class: "f-light" }
const _hoisted_31 = {
  class: "tab-pane",
  id: "top-produits",
  role: "tabpanel",
  "aria-labelledby": "top-produits-tab"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = {
  class: "table display",
  id: "project-status"
}
const _hoisted_35 = { class: "product-names" }
const _hoisted_36 = { class: "light-product-box" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "f-light" }
const _hoisted_39 = { class: "f-light" }
const _hoisted_40 = { class: "f-light" }
const _hoisted_41 = { class: "f-light" }
const _hoisted_42 = { class: "f-light" }
const _hoisted_43 = { class: "f-light" }
const _hoisted_44 = { class: "f-light" }
const _hoisted_45 = { class: "product-action" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  class: "tab-pane fade",
  id: "top-inventaire-partielle",
  role: "tabpanel",
  "aria-labelledby": "top-inventaire-partielle-tab"
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "badge badge-primary" }
const _hoisted_50 = { class: "f-w-500 mt-1" }
const _hoisted_51 = { class: "d-flex" }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "flex-grow-1" }
const _hoisted_54 = { class: "row details" }
const _hoisted_55 = { class: "col-6 font-primary" }
const _hoisted_56 = { class: "customers" }
const _hoisted_57 = ["src", "data-original-title", "title"]
const _hoisted_58 = { class: "d-inline-block ms-2" }
const _hoisted_59 = { class: "f-12" }
const _hoisted_60 = { class: "project-status mt-4" }
const _hoisted_61 = { class: "d-flex mb-0" }
const _hoisted_62 = {
  class: "progress",
  style: {"height":"5px"}
}
const _hoisted_63 = ["aria-valuemin"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Card3 = _resolveComponent("Card3")!
  const _component_ModalModifierProdCondMagInv = _resolveComponent("ModalModifierProdCondMagInv")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
              _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales")
            ], -1)),
            (_ctx.inventaire)
              ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[1] || (_cache[1] = _createElementVNode("th", null, "Référence", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.inventaire.refInventaire), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("th", null, "Période", -1)),
                      _createElementVNode("td", null, "De " + _toDisplayString(_ctx.format_Date(_ctx.inventaire.dateDebut)) + " à " + _toDisplayString(_ctx.format_Date(_ctx.inventaire.dateFin)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("th", null, "Type inventaire ", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.inventaire.typeInventaire), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("th", null, "Etat", -1)),
                      (_ctx.inventaire.estCloturer == true)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, _cache[3] || (_cache[3] = [
                            _createElementVNode("span", { class: "badge text-success" }, _toDisplayString("Cloturer"), -1)
                          ])))
                        : (_openBlock(), _createElementBlock("td", _hoisted_8, _cache[4] || (_cache[4] = [
                            _createElementVNode("span", { class: "badge text-danger" }, _toDisplayString("En cours"), -1)
                          ])))
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("th", { colspan: "2" }, "Motif", -1)),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.inventaire.motif), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, [
                    _createVNode(_component_vue_feather, { type: "info" }),
                    _cache[9] || (_cache[9] = _createTextVNode("Equipe"))
                  ])
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _createElementVNode("a", _hoisted_19, [
                    _createVNode(_component_vue_feather, { type: "info" }),
                    _cache[10] || (_cache[10] = _createTextVNode("Produits"))
                  ])
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _createElementVNode("a", _hoisted_21, [
                    _createVNode(_component_vue_feather, { type: "check-circle" }),
                    _cache[11] || (_cache[11] = _createTextVNode("Inventaire Partielle"))
                  ])
                ])
              ])
            ]),
            (_ctx.checkPermission('EditInventaireEtat'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "form-group mb-0 me-0" }, null, -1)),
                  (_ctx.inventaire?.estCloturer == false)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-danger",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cloturer())),
                        type: "button"
                      }, _cache[12] || (_cache[12] = [
                        _createElementVNode("i", { "data-feather": "plus-square" }, null, -1),
                        _createTextVNode("Clôturer ")
                      ])))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_Card3, { colClass: "col-sm-12" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("table", _hoisted_27, [
                    _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Nom")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Prénom")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Role")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipes, (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "product-removes",
                          key: index
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", null, _toDisplayString(row.user?.nom), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_29, _toDisplayString(row.user?.prenom), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_30, _toDisplayString(row.role?.nom), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("table", _hoisted_34, [
                    _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Produit")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Qté Fiche")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Qté Log ")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Qté Phy")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Qte Avariée")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Ecart Log")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Ecart Phy")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Qté ApI")
                        ]),
                        _createElementVNode("th", null, [
                          _createElementVNode("span", { class: "f-light f-w-600" }, "Action")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventaiprocondimags, (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "product-removes",
                          key: index
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("img", {
                                  class: "img-fluid",
                                  src: _ctx.getUrlApiForProductFiles(),
                                  alt: "imageFichier"
                                }, null, 8, _hoisted_37)
                              ]),
                              _createElementVNode("p", null, _toDisplayString(row.nomProd), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_38, _toDisplayString(row.qteFiche), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_39, _toDisplayString(row.qteLogique), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_40, _toDisplayString(row.qtePhysique), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_41, _toDisplayString(row.qteAvariee), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_42, _toDisplayString(row.qtePhysique - row.qteLogique), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_43, _toDisplayString(row.qtePhysique - row.qteFiche), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_44, _toDisplayString(row.qteTotalApresMouv), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#ModalModifierProdCondMagInv",
                                onClick: ($event: any) => (_ctx.modifier(row))
                              }, _cache[15] || (_cache[15] = [
                                _createElementVNode("svg", null, [
                                  _createElementVNode("use", { href: _hoisted_1 })
                                ], -1)
                              ]), 8, _hoisted_46)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventairePartielles, (inventaire, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-xxl-4 col-lg-4 col-md-6",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["project-box", inventaire.estCloturer == true ? 'b-light1-success' : 'b-light1-primary'])
                    }, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(inventaire.magasin.nomMagasin), 1),
                      _createElementVNode("h5", _hoisted_50, _toDisplayString(inventaire.typeInventaire + ' N° : ' + inventaire.refInventaire), 1),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("img", {
                          class: "img-20 me-1 rounded-circle",
                          src: _ctx.getImages("user/3.jpg"),
                          alt: "",
                          "data-original-title": "",
                          title: ""
                        }, null, 8, _hoisted_52),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("p", null, "Du " + _toDisplayString(_ctx.format_Date(inventaire.dateDebut)) + " au " + _toDisplayString(_ctx.format_Date(inventaire.dateFin)), 1)
                        ])
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("p", null, _toDisplayString("Détails"), -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-6" }, [
                          _createElementVNode("span", null, "Nmbre Produits ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_55, _toDisplayString(inventaire.inventaiprocondimags.length), 1)
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("hr", null, null, -1)),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inventaire.equipes, (equipe, eqIn) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "d-inline-block",
                              key: eqIn
                            }, [
                              _createElementVNode("img", {
                                class: "img-30 rounded-circle",
                                src: _ctx.getImages("user/1.jpg"),
                                alt: "",
                                "data-original-title": equipe.user?.nom + ' ' + equipe.user?.prenom,
                                title: equipe.user?.nom + ' ' + equipe.user?.prenom
                              }, null, 8, _hoisted_57)
                            ]))
                          }), 128)),
                          _createElementVNode("li", _hoisted_58, [
                            _createElementVNode("p", _hoisted_59, [
                              _createVNode(_component_router_link, {
                                class: "dropdown-item d-flex align-items-center",
                                to: { name: 'DetailInventairePage', params: { id: inventaire.id } }
                              }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode(" Aller vers l'inventaire")
                                ])),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("p", null, _toDisplayString(inventaire.estCloturer == true ? "100" : "50") + "% ", 1),
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex-grow-1 text-end" }, [
                            _createElementVNode("span", null, "Etat")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["progress-bar-animated", (inventaire.estCloturer == true ? 'bg-success' : 'bg-warning')]),
                            role: "progressbar",
                            style: _normalizeStyle({ 'width': (inventaire.estCloturer == true ? '100' : '50') + '%' }),
                            "aria-valuenow": "10",
                            "aria-valuemin": (inventaire.estCloturer == true ? 10 : 0),
                            "aria-valuemax": "100"
                          }, null, 14, _hoisted_63)
                        ])
                      ])
                    ], 2)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ModalModifierProdCondMagInv, {
      item: _ctx.element,
      onClose: _ctx.rafraichir,
      ref: "editModalModifierProdCondMagInv"
    }, null, 8, ["item", "onClose"])
  ], 64))
}